'use strict';

import React from 'react';

const BaseQuestionnaireListItem = ({
  left,
  leftWidth = 'span6',
  center,
  centerWidth = 'span3',
  right,
  rightWidth = 'span3',
}) => (
  <li className="ot-queryitem row-fluid">
    <div className={`ot-queryitem__info ot-queryitem__info--left ${leftWidth}`}>
      {left}
    </div>
    <div
      className={`ot-queryitem__info ot-queryitem__info--center ${centerWidth}`}
    >
      {center}
    </div>
    <div
      className={`ot-queryitem__info ot-queryitem__info--right ${rightWidth}`}
    >
      {right}
    </div>
  </li>
);

export default BaseQuestionnaireListItem;
